import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CookieDetail } from '@/app/types/cookieConsentType'
import { useTranslation } from '@/app/i18n/client'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
interface CookiesSubModalProps {
  cookieDetails: CookieDetail[] | undefined
}

const CookiesSubModal = ({ cookieDetails }: CookiesSubModalProps) => {
  const { t } = useTranslation()

  return (
    <div className="mx-5 my-2 ">
      <div className="border rounded-md">
        <Accordion
          sx={{
            boxShadow: 'none',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ paddingY: 0, height: 5 }}
          >
            <label className="font-medium  cursor-pointer">
              {t('Fructidor.com')}
            </label>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <div
              className={`border-t flex flex-col gap-4 transition  divide-y divide-[#E5E7EB] px-5 py-3`}
            >
              {cookieDetails &&
                cookieDetails?.map((cookie, index) => (
                  <div
                    key={index}
                    className="group hover:bg-[#fafafa] p-3 rounded-md transition"
                  >
                    <h4 className="font-medium text-sm transition">
                      {cookie.name}
                    </h4>
                    <p className="text-sm text-[#8b8b8b] mt-2">
                      {t(cookie.description)}
                    </p>
                    <div className="grid grid-cols-3 gap-2 mt-2 text-xs">
                      <div>
                        <p className="text-[#6b6b6b] ">{t('Type')}</p>
                        <p>{t(cookie.type)}</p>
                      </div>
                      <div>
                        <p className="text-[#6b6b6b] ">{t('Duration')}</p>
                        <p>{t(cookie.duration)}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  )
}

export default CookiesSubModal
